import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class Common {

  // private apiBaseUrl = 'http://localhost:3000/api';  // URL to web api
  // private apiBaseUrl = 'http://127.0.0.1:3000';  // URL to web api
  //private apiBaseUrl = 'https://ngnodesrv.azurewebsites.net';  // URL to web api
  private apiBaseUrl = environment.apiUrl;
  constructor(private http: HttpClient, private datePipe: DatePipe) { }

  WebTrack(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/front/WebTrack',postData)
  }

  SaveSearchPref(postData): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl+'/front/SaveSearchPref',postData);
  }

}
